<template>
    <span class="ah-el-select-dep">
        <el-select
            ref="select"
            v-model="inputVal"
            style="min-width: 250px;"
            filterable
            placeholder="部門名稱"
            :filter-method="filterMethod"
            @blur="handleBlur"
            @keydown.native.capture.enter="preventIMESelect"
        >
            <template slot="empty">
                <div class="quick-add-inputs" style="padding: 12px">
                    <el-row :gutter="5">
                        <el-col :span="18">
                            <el-input size="small" v-model="nameForQuickAdd"></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-button size="small" type="primary" @click="handleQuickAddSubmit">新增</el-button>
                        </el-col>
                    </el-row>
                </div>
            </template>
            <el-option v-for="item in optionsCopy" :key="item.sno" :label="item.deP_NAM" :value="item.sno">
                <span style="float: left">{{ item.deP_NAM }}</span>
                <el-button style="float: right; color: #ccc" type="text" size="small" @click="handleItemEditClick(item)">編輯</el-button>
            </el-option>
        </el-select>
        <el-popover v-model="editPopoverVisiable" class="quick-edit-popup" ref="editPopover" placement="right">
            <div class="quick-edit-inputs">
                <div style="margin-bottom: 10px;">
                    <el-input ref="quickEditInput" v-model="quickEdit.name"></el-input>
                </div>
                <div>
                    <el-popconfirm confirm-button-text="是的" cancel-button-text="取消" icon="el-icon-info" icon-color="red" title="確定要刪除嗎？" @onConfirm="handleQuickEditDelete">
                        <el-button slot="reference" size="small" type="danger" plain style="margin-right: 10px">刪除</el-button>
                    </el-popconfirm>
                    <el-button size="small" type="" @click="handleQuickEditCancel">取消</el-button>
                    <el-button size="small" type="primary" style="width: 120px" @click="handleQuickEditSubmit">儲存</el-button>
                </div>
            </div>
        </el-popover>
    </span>
</template>
<script>
export default {
    name: 'ah-el-select-dep',
    props: ['value'],
    components: {},
    data() {
        return {
            departmentList: [],
            vendorList: [],
            outsourcingList: [],
            options: [],
            optionsCopy: [],
            nameForQuickAdd: '',
            editPopoverVisiable: false,
            quickEdit: {
                name: '',
                sno: null,
            },
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        // 取得下拉選單資料
        fetchData(nameToSelect) {
            this.$api({
                url: '/DepartmentSettingPage/GetDepartmentSettings',
                method: 'GET',
            }).then((resp) => {
                // 原有資料保存(for upsert使用)
                this.departmentList = resp.data.departmentSettings;

                // 列表資料
                this.options = resp.data.departmentSettings;
                this.optionsCopy = this.options.filter(() => true);

                // 指定選取
                if (nameToSelect) {
                    const item = this.options.find((item) => item.deP_NAM == nameToSelect);
                    if (item) {
                        this.inputVal = item.sno;
                        this.$refs.select.blur();
                    }
                }
            });
        },

        // 焦點消失（恢復）
        handleBlur() {
            // this.optionsCopy = this.options.filter(() => { return true })
        },

        // 新增項目
        handleQuickAddSubmit() {
            // 加入原有列表
            this.nameForQuickAdd = this.nameForQuickAdd.trim();
            this.departmentList.push({ sno: null, deP_NAM: this.nameForQuickAdd, sot: 0 });

            // 新增
            this.$api({
                url: '/DepartmentSettingPage/UpsertDepartmentSettings',
                method: 'POST',
                data: {
                    departmentSettings: this.departmentList,
                },
            }).then(() => {
                // 重新載入，選取剛新增項目
                this.fetchData(this.nameForQuickAdd);
            });
        },

        // 輸入時過濾方法
        filterMethod(val) {
            // 搜尋
            if (val) {
                this.optionsCopy = this.options.filter(
                    (item) =>
                        // 比對
                        item.deP_NAM.toLowerCase().indexOf(val.toLowerCase()) > -1,
                );

                // 給搜尋不到時新增的參數
                if (this.optionsCopy.length <= 0) {
                    this.nameForQuickAdd = val;
                }
            } else {
                this.optionsCopy = this.options.filter(() => true);
            }
        },

        handleItemEditClick(item) {
            this.editPopoverVisiable = true;
            this.quickEdit.name = item.deP_NAM;
            this.quickEdit.sno = item.sno;

            setTimeout(() => {
                this.$refs.quickEditInput.focus();
            }, 10);
        },

        handleQuickEditSubmit() {
            this.editPopoverVisiable = false;

            // 修改原有列表
            this.quickEdit.name = this.quickEdit.name.trim();
            this.departmentList.forEach((item) => {
                if (item.sno === this.quickEdit.sno) {
                    item.deP_NAM = this.quickEdit.name;
                }
            });

            // 送出修改
            this.$api({
                url: '/DepartmentSettingPage/UpsertDepartmentSettings',
                method: 'POST',
                data: {
                    departmentSettings: this.departmentList,
                },
            }).then(() => {
                // 重新載入，選取剛新增項目
                this.fetchData(this.quickEdit.name);
            });
        },

        handleQuickEditCancel() {
            this.editPopoverVisiable = false;
        },

        handleQuickEditDelete() {
            this.editPopoverVisiable = false;

            // 從原有列表中移除
            this.quickEdit.name = this.quickEdit.name.trim();
            this.departmentList = this.departmentList.filter((item) => item.sno !== this.quickEdit.sno);

            // 送出修改
            this.$api({
                url: '/DepartmentSettingPage/UpsertDepartmentSettings',
                method: 'POST',
                data: {
                    departmentSettings: this.departmentList,
                },
            }).then(() => {
                // 重新載入，不選取
                this.fetchData();
                this.inputVal = null;
                this.$refs.select.focus();
            });
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
.ah-el-select-dep .el-input > input {
    cursor: text;
}

.ah-el-select-dep .quick-edit-popup {
    padding: 12px;

    .el-popover {
        margin-top: -50px;
        border-radius: 10px;
    }
}
</style>
